export default "__VITE_ASSET__CfmxJ15w__"